import React from 'react'
import PropTypes from 'prop-types'
import { HippostdHtml } from './HippostdHtml.jsx'
const CtiImageCompound = ({
  imageUrl,
  alt,
  title,
  caption,
  classNames,
  imgClasses = 'u-paddingVert2gu',
  downloadUrl = '',
}) => {
  function renderImage() {
    return (
      <img
        className={`${imgClasses}`}
        src={imageUrl}
        alt={alt || title || ''}
      />
    )
  }
  return imageUrl ? (
    <div className={`CtiImageCompound ${classNames || ''}`}>
      {title && <h3>{title}</h3>}
      {downloadUrl ? (
        <a href={downloadUrl} target="_blank" rel="noreferrer">
          {renderImage()}
        </a>
      ) : (
        renderImage()
      )}
      {caption && (
        <div>
          <hr className="Rule" role="presentation" />
          <HippostdHtml value={caption} />
        </div>
      )}
    </div>
  ) : null
}

// imageUrl  needs to be set explicitly using
// page.getContent(image.$ref).getOriginal().getUrl()
CtiImageCompound.propTypes = {
  imageUrl: PropTypes.string,
  image: PropTypes.shape({
    $ref: PropTypes.string,
  }),
  alt: PropTypes.string,
  title: PropTypes.string,
  overlay: PropTypes.bool,
  overlayLink: PropTypes.string,
  alignment: PropTypes.string,
  caption: PropTypes.string,
  classNames: PropTypes.string,
  imgClasses: PropTypes.string,
  name: PropTypes.string,
  displayName: PropTypes.string,
  downloadUrl: PropTypes.string,
}

export { CtiImageCompound }
